import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import * as verificationActions from '../actions/verification';
import isEmpty from '../utils/emptyObject';

const {OKNAME_URL} = verificationActions;

class Verification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      iPinPopup: {},
      smsPopup: {}
    };
  }

  componentDidMount() {
    if (window.self === window.top) {
      document.body.className += ' verification-bg';
    }

    window.addEventListener(
      'message',
      event => {
        if (event.origin === OKNAME_URL) {
          if (!isEmpty(this.state.iPinPopup)) {
            verificationActions
              .ipinCallbackAsync(this.props.dispatch, event.data, this.props.location.query)
              .then(() => {
                this.state.iPinPopup.close();
                this.setState({iPinPopup: {}});
              });
          } else {
            verificationActions
              .smsCallbackAsync(this.props.dispatch, event.data, this.props.location.query)
              .then(() => {
                this.state.smsPopup.close();
                this.setState({smsPopup: {}});
              });
          }
        }
      },
      false
    );
  }

  iPinAuthentication() {
    this.closeAllWindows();
    this.setState({
      iPinPopup: verificationActions.ipinAsync(this.props.dispatch),
      smsPopup: {}
    });
  }

  smsAuthentication() {
    this.closeAllWindows();
    this.setState({
      smsPopup: verificationActions.smsAsync(this.props.dispatch),
      iPinPopup: {}
    });
  }

  closeAllWindows() {
    if (!isEmpty(this.state.smsPopup)) {
      this.state.smsPopup.close();
    }
    if (!isEmpty(this.state.iPinPopup)) {
      this.state.iPinPopup.close();
    }
  }

  render() {
    return (
      <div className="verification-page">
        <div className="verification-page_wrapper">
          <div className="verification-page_wrapper_logotype" />

          <div className="verification-page_wrapper_description">
            게임 계정을 생성하기 전에 신원을 확인하세요. <br /> 본인 인증 수단을 선택하세요.
          </div>

          <div className="verification-page_wrapper_cards">
            <div className="item-card" data-testid="sms" onClick={() => this.smsAuthentication()}>
              <div className="item-card_title">휴대전화 본인 인증</div>

              <div className="item-card_description">
                본인 소유의 휴대전화 정보를 입력한 후 인증 번호를 입력하면 사용자 본인을 확인할 수
                있습니다.
              </div>
            </div>

            <div className="item-card" data-testid="ipin" onClick={() => this.iPinAuthentication()}>
              <div className="item-card_title">아이핀(I-Pin) 인증</div>

              <div className="item-card_description">
                아이핀(I-Pin)은 주민등록번호를 사용하지 않고도 본인임을 확인할 수 있는 개인정보보호
                서비스입니다.
              </div>
            </div>
          </div>

          <div className="verification-page_wrapper_footer">
            <ul>
              <li>
                <Link to="https://wauth.teledit.com/Danal/WebAuth/Web/Guide.php" target="_blank">
                  모바일 인증에 대해 자세히 알아보기
                </Link>
              </li>
              <li>
                <Link to="http://i-pin.kisa.or.kr/kor/issue/institution.jsp" target="_blank">
                  I-Pin 인증에 대해 자세히 알아보기
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

Verification.propTypes = {
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect(state => state)(Verification);



// WEBPACK FOOTER //
// ./pages/Verification.jsx